export default __webpack_public_path__ + "static/media/icon-clock-fill2.2cc211ef.svg";